// =============================================================================
// features/sales/campaigns/wizard/labels.ts — Rótulos em português usados em
// mais de uma etapa do wizard (F35-S08). Centralizados para não divergir
// entre a prévia de higiene (etapa 3) e o resumo da revisão (etapa 6).
// =============================================================================

import type { AssignmentStrategy, LeadStatus } from '@elemento/shared-schemas';
import type { AudienceCounts } from '@elemento/shared-schemas';

export const LEAD_STATUS_OPTIONS: { value: LeadStatus; label: string }[] = [
  { value: 'new', label: 'Novo' },
  { value: 'qualifying', label: 'Qualificando' },
  { value: 'simulation', label: 'Simulação' },
  { value: 'closed_won', label: 'Convertido' },
  { value: 'closed_lost', label: 'Perdido' },
  { value: 'archived', label: 'Arquivado' },
];

export const ASSIGNMENT_STRATEGY_OPTIONS: {
  value: AssignmentStrategy;
  label: string;
  hint: string;
}[] = [
  {
    value: 'shared_queue',
    label: 'Fila compartilhada',
    hint: 'Qualquer vendedor habilitado reserva o próximo cliente disponível.',
  },
  {
    value: 'round_robin',
    label: 'Rodízio',
    hint: 'A carteira é distribuída em sequência entre os vendedores do time.',
  },
  {
    value: 'fixed_owner',
    label: 'Dono fixo',
    hint: 'Cada cliente permanece com o mesmo vendedor até o fim da campanha.',
  },
];

/** Uma entrada por categoria de `AudienceCounts` — ordem de exibição fixa. */
export const HYGIENE_CATEGORY_ORDER: (keyof AudienceCounts)[] = [
  'new',
  'reused',
  'alreadyPresent',
  'duplicate',
  'invalid',
  'blocked',
];

export const HYGIENE_CATEGORY_LABEL: Record<keyof AudienceCounts, string> = {
  new: 'Novos',
  reused: 'Reutilizados',
  duplicate: 'Duplicados',
  invalid: 'Inválidos',
  blocked: 'Bloqueados',
  alreadyPresent: 'Já presentes',
};

export const HYGIENE_CATEGORY_REASON: Record<keyof AudienceCounts, string> = {
  new: 'Nunca trabalhados em nenhuma campanha — entram como membro novo.',
  reused: 'Já estão em outra campanha ativa/pausada, mas ainda assim entram nesta.',
  duplicate:
    'Mesmo cliente repetido no próprio filtro ou na própria lista — só a 1ª entrada conta.',
  invalid:
    'Não encontrados no seu escopo de cidade ou sem telefone utilizável — não entram na fila.',
  blocked:
    'Preferência de contato bloqueada para telefone — ficam registrados, mas nunca entram na fila.',
  alreadyPresent: 'Já são membros desta campanha — não são inseridos de novo.',
};

/** `true` para categorias que a API materializa (`willMaterialize`/`materializedCount`). */
export const HYGIENE_CATEGORY_MATERIALIZES: Record<keyof AudienceCounts, boolean> = {
  new: true,
  reused: true,
  duplicate: false,
  invalid: false,
  blocked: true,
  alreadyPresent: false,
};
